/* This file was generated automatically. Do not edit manually. */

export enum GeneralServiceDocumentType {
    TermsAndConditions = 'TermsAndConditions',
    PrivacyPolicy = 'PrivacyPolicy',
    CheckInInstructions = 'CheckInInstructions',
    CheckOutInstructions = 'CheckOutInstructions',
    Rules = 'Rules',
    SelfRequiredText = 'SelfRequiredText',
    IdentityDocumentRequiredText = 'IdentityDocumentRequiredText',
}
